module.exports = __webpack_public_path__ + "img/chatFolder.b50ba703.png";